import * as React from "react";
const TestMenu = ({ color = "#276AA6", ...props }) => (
  <svg
    width={20}
    height={22}
    viewBox="0 0 20 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.9981 17.8605H15.2377C14.4372 17.8605 13.6767 18.1707 13.1163 18.731L11.4053 20.4221C10.6248 21.1926 9.35399 21.1926 8.5735 20.4221L6.86243 18.731C6.30208 18.1707 5.5316 17.8605 4.74111 17.8605H3.99064C2.32961 17.8605 0.98877 16.5297 0.98877 14.8887V3.97182C0.98877 2.3308 2.32961 1 3.99064 1H15.9981C17.6592 1 19 2.3308 19 3.97182V14.8887C19 16.5197 17.6592 17.8605 15.9981 17.8605Z"
      stroke={color}
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.99072 8.15486C4.99072 7.22428 5.7512 6.46375 6.68178 6.46375C7.61236 6.46375 8.37284 7.22428 8.37284 8.15486C8.37284 10.036 5.70116 10.2362 5.11079 12.0273C4.99072 12.3975 5.30091 12.7677 5.69116 12.7677H8.37284"
      stroke={color}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.0365 12.7574V7.04392C14.0365 6.78376 13.8664 6.55356 13.6162 6.48351C13.3661 6.41347 13.0959 6.51353 12.9558 6.73367C12.2354 7.89439 11.4549 9.21523 10.7744 10.376C10.6644 10.5661 10.6644 10.8162 10.7744 11.0064C10.8845 11.1965 11.0946 11.3165 11.3248 11.3165H14.9971"
      stroke={color}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default TestMenu;